import React, { useMemo } from 'react';
import { components } from 'react-select';

import { Icon, IconSize } from 'app/design-system/components/Icon';
import { type ComponentsConfig, Option } from 'app/widgets/Dropdown/Single';

import { StakeTypeGroup } from '../../constants';

import styles from './ColumnsHeader.module.scss';

// ---

export type ColumnOption = {
  label: string;
  value: keyof typeof StakeTypeGroup;
};

// ---

function DropdownComponents(
  headerPosition: number,
  dataGaEvent?: string,
): ComponentsConfig<ColumnOption> {
  return useMemo(() => ({
    MenuPortal: (props) => (
      <components.MenuPortal {...props}>
        <div className={styles.portal}>
          {props.children}
        </div>
      </components.MenuPortal>
    ),
    Option: (props) => {
      return (
        <Option {...props}
                customInnerProps={{
                  ['data-ga-event']: dataGaEvent,
                  ['data-ga-event-content']: headerPosition,
                  ['data-ga-event-value']: StakeTypeGroup[props.data.value],
                }}>
          {props.children}
        </Option>
      );
    },
    DropdownIndicator: (props) => (
      <components.DropdownIndicator {...props}>
        <Icon icon="micro-chevron-down"
              className={styles.iconIndicator}
              size={IconSize.SMALL} />
      </components.DropdownIndicator>
    ),
  }), [headerPosition, dataGaEvent]);
}

export default DropdownComponents;
